var EEqualVersion;
/**
 * 对比客户端版本号
 * @param version2 传入要比对的版本号
 * @returns 当前客户端版本小于传入的版本 => -1，等于 => 0，大于 => 1
 */

(function (EEqualVersion) {
  EEqualVersion[EEqualVersion["LOW"] = -1] = "LOW";
  EEqualVersion[EEqualVersion["EQUQL"] = 0] = "EQUQL";
  EEqualVersion[EEqualVersion["HEIGHT"] = 1] = "HEIGHT";
})(EEqualVersion || (EEqualVersion = {}));

export function compareClientVersion(version1, version2) {
  if (version1 == version2) return 0;
  var v1 = version1.split('.');
  var v2 = version2.split('.');
  var i = 0;

  while (v1[i] && v2[i]) {
    if (+v1[i] == +v2[i]) {
      i += 1;
      continue;
    }

    return +v1[i] > +v2[i] ? EEqualVersion.HEIGHT : EEqualVersion.LOW;
  }

  if (v1[i]) return EEqualVersion.HEIGHT;
  if (v2[i]) return EEqualVersion.LOW;
  return EEqualVersion.EQUQL;
}
/**
 * 获取客户端版本号
 */

export function getUAClientVersion(flag) {
  var ua = navigator.userAgent.toLowerCase();
  var regVersionResult = ua.match(new RegExp("".concat(flag, "\\/(\\d+\\.\\d+\\.\\d+)"))) || ua.match(new RegExp("".concat(flag, "\\/(\\d+\\.\\d+)")));
  return regVersionResult ? regVersionResult[1] : '';
}
export function escapeUrl(url) {
  var regMail = /^(mailto:(\/\/)?)?([a-z\u00a1-\uffff0-9_\-.])+@([a-z\u00a1-\uffff0-9_\-.])+\.([a-z]{2,})$/i; // 识别为邮箱

  if (regMail.test(url)) {
    url = url.replace(/^(mailto:(\/\/)?)?/i, 'mailto:');
  } else if (!/^(https?|ftp|file):\/\//i.test(url)) {
    if (/^(doc\.weixin\.qq\.com)/i.test(url)) {
      url = "https://".concat(url);
    } else {
      url = "http://".concat(url);
    }
  }

  return url;
}